export const domTomCheck = (zipCode: string) => {

    // Code postaux des DOM TOM
    const domTom: string[] = ['971', '972', '973', '974', '975', '976', '977', '978', '984', '986', '987', '988', '989'];
    const checkDomTomZipCode = domTom.find((element: string) => element.includes(zipCode.substring(0, 3)));

    // Return value | undefined
    return checkDomTomZipCode;
};
